import { render } from "./BookComposition.vue?vue&type=template&id=e96acb28"
import script from "./BookComposition.vue?vue&type=script&lang=js"
export * from "./BookComposition.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__